/** @format */

import {styled} from '@mui/material/styles';
import {TableRow, TableSortLabel} from '@mui/material';

import {TableVariant} from '../../types';

interface TableSortLabelProps {
  sorted?: boolean;
}

export const StyledTableSortLabel = styled(TableSortLabel, {
  shouldForwardProp: prop => prop !== 'sorted',
})<TableSortLabelProps>(({theme, sorted}) => ({
  width: '100%',
  height: '100%',
  path: {
    fill: theme.palette.figma_gray_light_1?.main,
  },

  '.MuiSvgIcon-root': {
    opacity: sorted ? 1 : 0,
  },

  '&:hover .MuiSvgIcon-root': {
    opacity: sorted ? 1 : 0,
  },
}));

interface StyledTableHeadRowProps {
  variant: TableVariant;
}

export const StyledTableHeadRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'variant',
})<StyledTableHeadRowProps>(({theme, variant}) => ({
  backgroundColor: variant === 'dark' ? '#202020' : '#F2F3F8',

  // Стили текста по умолчанию для всех Typography
  '.MuiTableCell-root .MuiTypography-root': {
    color:
      variant === 'dark'
        ? theme.palette.figma_gray_light_1?.main
        : theme.palette.figma_gray_dark_5?.main,
    fontSize: variant === 'light' ? '14px' : '16px',
    fontWeight: variant === 'light' ? 400 : 700,
    lineHeight: variant === 'light' ? '16px' : '18px',
    letterSpacing: variant === 'dark' ? '0.32px' : 'normal',
  },
}));
